module.exports = __webpack_public_path__ + "static/media/mbtml-logo-s.4fe7a2b1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/mbtml-logo-s.svg
// module id = 608
// module chunks = 0